import Raven from 'raven-js';
export function throwCommandError(errorMessage) {
  var _hubspot;
  const error = new Error(errorMessage);
  console.warn(errorMessage);
  Raven.captureException(error, {
    fingerprint: [errorMessage, ((_hubspot = window.hubspot) === null || _hubspot === void 0 || (_hubspot = _hubspot.bender) === null || _hubspot === void 0 ? void 0 : _hubspot.currentProject) || 'unknown-project']
  });
}